module.exports = __webpack_public_path__ + "img/near.9f330d4d.svg";